import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  commissionOnMedia: EMPTY_STRING,
  slidingScale: EMPTY_STRING,
  thirdPartyFee: EMPTY_STRING,
  entries: [],
};
